import ContentElement from "./content-element.js";
import ScrollTo from "../component/scroll-to.js";

const DEFAULT_ELEMENT_SELECTOR: string = '.th-fsc-media-playlist';


class MediaPlaylist extends ContentElement {

    public override init() {
    }

    public override process() {
        const self = this;

        const mediaItemElements = this.element.querySelectorAll<HTMLElement>('.playlist-item');
        const indexItemElements = this.element.querySelectorAll<HTMLElement>('.playlist-index-item');
        const playerFrameEl = this.element.querySelector<HTMLElement>('.playlist-main');
        if(playerFrameEl) {
            playerFrameEl.style.display = 'none';
        }
        const playlistMedias: HTMLElement[] = [];

        mediaItemElements.forEach((el: HTMLElement) => {
            playlistMedias.push(el);
        });

        const showItem = function(selectedItem: number) {
            indexItemElements.forEach((el: HTMLElement, key: number) => {
                el.classList.remove('active');
            });
            mediaItemElements.forEach((el: HTMLElement, key: number) => {
                el.style.display = 'none';
                if(key == selectedItem) {
                    el.style.display = 'block';
                    if(indexItemElements[key]) {
                        indexItemElements[key].classList.add('active');
                    }
                }
            });
        }

        indexItemElements.forEach((el: HTMLElement, key: number) => {
            const identifier = el.dataset.identifier;
            el.addEventListener('click', () => {
                showItem(key);
                if(window.ThiemeMaintemplate.getScreenSize().key < 2) {
                    ScrollTo.scrollTo(self.element, { offset: 10 });
                }

            });
            if(window.location.href.search('#media-'+identifier) > -1) {
                showItem(key);
            } else {
                if(key === 0) {
                    showItem(0);
                }
            }
        });

    }
}

// Observe
MediaPlaylist.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export default MediaPlaylist;
